<template>
  <div>
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <div>
            <h4 class="title is-4">{{ title }}</h4>
            <h6 class="title is-6" v-if="evaluators.length">Count: {{ evaluators.length }}</h6>
          </div>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <button class="button" @click="exportData(exportUrl)">
            Export
          </button>
        </div>
        <div class="level-item">
          <button class="button" @click="emailEvaluators()">
            Email Evaluators
          </button>
        </div>
        <div class="level-item" v-if="evaluators.length">
          <button class="button" v-if="listVisible" @click="listVisible = !listVisible">
            Hide List of Evaluators
          </button>
          <button class="button" v-if="!listVisible" @click="listVisible = !listVisible">
            Show List of Evaluators
          </button>
        </div>
      </div>
    </div>
    <table class="table" v-if="evaluators.length && listVisible">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Completed Evaluations</th>
          <th>Email Evaluator</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="evaluator in evaluators" :key="evaluator.id">
          <td>
            <router-link
              :to="{
                name: 'EvaluatorDetail',
                params: { evaluatorId: evaluator.id },
              }"
              target="_blank"
              >{{ evaluator.fullName }}
            </router-link>
          </td>
          <td>
            <router-link
              :to="{
                name: 'EvaluatorDetail',
                params: { evaluatorId: evaluator.id },
              }"
              target="_blank"
              >{{ evaluator.email }}
            </router-link>
          </td>
          <td>{{ evaluator.numCompletedEvaluations }}</td>
          <td>
            <button class="button" @click="sendEmailToEvaluator(evaluator)">
              Send Individual Email
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <BulkEmailModal
      v-if="showModal"
      :users="selectedEvaluators"
      @close="showModal = !showModal"
      @submit="refreshData()"
    />
  </div>
</template>

<script>

import Report from '@/services/reports'
import BulkEmailModal from '@/components/emails/BulkEmailModal'

export default {
  components: { BulkEmailModal },
  name: 'ReportLoader',
  props: {
    title: {
      type: String,
      default: '',
    },
    evaluators: {
      type: Array,
      default: () => [],
    },
    exportUrl: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      listVisible: false,
      showModal: false,
    }
  },
  methods: {
    refreshData(page = null){
      this.showModal = false
    },
    exportData(exportURL) {
      Report.api
        .retrieveExport(exportURL)
        .then(response => {
          this.$Alert.alert({
            type: 'success',
            message: `Export Successful`,
            timeout: 6000,
          })
        })
        .catch(err => {
          this.$Alert.alert({
            type: 'error',
            message: `Export Failed`,
            timeout: 6000,
          })
        })
    },
    emailEvaluators() {
      this.selectedEvaluators = [...this.evaluators]
      this.showModal = true
    },
    sendEmailToEvaluator(evaluator) {
      this.selectedEvaluators = [evaluator]
      this.showModal = true
    },
  },
}
</script>

<style lang="scss" scoped></style>
